 
  //noinspection BadExpressionStatementJS,UnterminatedStatementJS
 define({ 
         ok: "OK",
         cancel: "キャンセル",
         switchPanes: "ウィンドウの切り替え",
         close: "閉じる",
         yes: "はい",
         no: "いいえ"
     });

